import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "ngx-cookie-service";
import * as i3 from "ngx-cookieconsent";
var LocalizationService = /** @class */ (function () {
    function LocalizationService(translateService, cookieService, cookieConsentService) {
        this.translateService = translateService;
        this.cookieService = cookieService;
        this.cookieConsentService = cookieConsentService;
        this._subscribers = new Array();
        this._langSubject = new Subject();
        this.CULTURE_COOKIE_KEY = '.AspNetCore.Culture';
    }
    LocalizationService.prototype.hasAnsweredAndConsented = function () {
        var config = this.cookieConsentService.getConfig();
        if (!config.enabled)
            return true;
        var hasAnswered = this.cookieConsentService.hasAnswered();
        var hasConsented = this.cookieConsentService.hasConsented();
        return hasAnswered && hasConsented;
    };
    LocalizationService.prototype.setDefaultLocale = function (locale) {
        if (this.hasAnsweredAndConsented())
            this.cookieService.set(this.CULTURE_COOKIE_KEY, "c=" + locale + "|uic=" + locale);
        localStorage.setItem('default-locale', locale);
    };
    LocalizationService.prototype.setLocale = function (locale) {
        if (this.hasAnsweredAndConsented())
            this.cookieService.set(this.CULTURE_COOKIE_KEY, "c=" + locale + "|uic=" + locale, null, '/');
        localStorage.setItem('locale', locale);
        this.translateService.use(locale);
    };
    /**
     * Get the locale code.  Example: fr-CA
     */
    LocalizationService.prototype.getLocale = function () {
        return localStorage.getItem('locale') || localStorage.getItem('default-locale') || 'fr-CA';
    };
    /**
     * Gets the text for the currently selected locale.  Returns an Observable.
     * @param key translation key
     */
    LocalizationService.prototype.translate = function (key, interpolateParams) {
        return this.translateService.get(key, interpolateParams);
    };
    /**
     * Instantly gets the text for the currently selected locale.
     * see: https://github.com/ngx-translate/core
     * @param key translation key
     */
    LocalizationService.prototype.instant = function (key, interpolateParams) {
        return this.translateService.instant(key, interpolateParams);
    };
    LocalizationService.prototype.addLangSubscriber = function (subscriber, action) {
        this._subscribers.push({
            subscriber: subscriber,
            action: action
        });
    };
    LocalizationService.prototype.initLangChange = function () {
        var _this = this;
        this.translateService.onLangChange.subscribe(function (event) {
            if (_this._subscribers.length) {
                // Filter out any subs that have been unsubscribed.
                _this._subscribers = _this._subscribers.filter(function (sub) { return !sub.subscriber.closed; });
                console.log('Lang Change Subs: ', _this._subscribers);
                for (var _i = 0, _a = _this._subscribers; _i < _a.length; _i++) {
                    var sub = _a[_i];
                    sub.action(sub.subscriber);
                }
            }
        });
    };
    LocalizationService.ngInjectableDef = i0.defineInjectable({ factory: function LocalizationService_Factory() { return new LocalizationService(i0.inject(i1.TranslateService), i0.inject(i2.CookieService), i0.inject(i3.NgcCookieConsentService)); }, token: LocalizationService, providedIn: "root" });
    return LocalizationService;
}());
export { LocalizationService };
